import type { ModuleTagEntry } from './index';

/** PET Series module tags. */
export const tags: ModuleTagEntry[] = [
  'CorrectedImage',
  'Units',
  'DecayCorrection',
];
